
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import { Lead } from '@/types';
import { getLeadCustomValueText } from '@/helpers';

@Component
export default class ConnectionLastStep extends Vue {
  @Prop(Object) readonly lead!: Lead | null;

  connectionLastStep: string | null = null
  connectionLastStepDescription: string | null = null

  created() {
    // Recupera le informazioni sullo stato della Connection
    this.connectionLastStep = getLeadCustomValueText(this.lead, 'connectionLastStep');
    this.connectionLastStepDescription = getLeadCustomValueText(this.lead, 'connectionLastStepDescription');
  }
}
